(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-specifications"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-specifications')) {
    customElements.define('product-specifications', class extends HTMLElement {
      updateFromHTML(html, variant) {
        if (!variant) {
          this.querySelectorAll('[data-variant-row]').forEach(row => row.hidden = true);
          this.dataset.variantId = '';
          return;
        }
        const source = html.getElementById(this.id);
        const body = this.querySelector('tbody');
        if (!source || !body) return;
        body.innerHTML = source.querySelector('tbody').innerHTML;
        this.dataset.variantId = String(variant.id);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
